import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { FadeUp, MaskedLineReveal } from "./motion/Reveal";
import { TEST_IDS } from "../constants/testIds";

const CHAPTERS = [
  {
    n: "01",
    title: "Vent'anni di cantiere",
    body:
      "Dal 1998, Foxtherm accompagna imprese, progettisti e privati con la stessa disciplina: capire l'edificio, scegliere il sistema, seguire la posa fino alla taratura finale.",
  },
  {
    n: "02",
    title: "Esecuzione al millimetro",
    body:
      "Ogni intervento viene realizzato con attenzione ai dettagli e concordato con il cliente, analizzando insieme le reali esigenze di chi poi vivrà davvero l'ambiente.",
  },
  {
    n: "03",
    title: "Assistenza continua",
    body:
      "Post-vendita, tarature stagionali, interventi di manutenzione, integrazioni con caldaie, pompe di calore e VMC. Restiamo il vostro riferimento anche dopo la fine dei lavori.",
  },
  {
    n: "04",
    title: "Multi-marca, senza vincoli",
    body:
      "Lavoriamo con i principali brand italiani ed europei. La scelta dei componenti nasce dalle esigenze del cantiere e dal budget, non da un rapporto commerciale.",
  },
];

export function ChiSiamo() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const yBg = useTransform(scrollYProgress, [0, 1], [-30, 60]);

  return (
    <section
      id="chi-siamo"
      ref={ref}
      data-testid={TEST_IDS.chi.section}
      className="relative py-28 md:py-44 border-t border-white/10 overflow-hidden"
    >
      <motion.div
        style={{ y: yBg }}
        className="pointer-events-none absolute -right-32 top-20 hidden md:block font-editorial italic text-[24rem] leading-none text-white/[0.025] select-none"
      >
        Metodo
      </motion.div>

      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-4">
            <FadeUp>
              <span className="eyebrow">
                <span className="inline-block mr-3 w-6 h-px bg-[#E31E24] align-middle" />
                Chi Siamo
              </span>
            </FadeUp>
          </div>
          <div className="col-span-12 md:col-span-8">
            <h2 className="font-display font-black uppercase tracking-tighter leading-[0.92] text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
              <MaskedLineReveal>Un metodo,</MaskedLineReveal>
              <MaskedLineReveal delay={0.15}>
                <span className="font-editorial italic font-light text-white/85">non solo</span>
              </MaskedLineReveal>
              <MaskedLineReveal delay={0.3}>una posa.</MaskedLineReveal>
            </h2>
          </div>
        </div>

        <div className="border-t border-white/10">
          {CHAPTERS.map((c, i) => (
            <FadeUp key={c.n} delay={i * 0.08}>
              <div
                data-testid={TEST_IDS.chi.chapter(c.n)}
                className="group border-b border-white/10 py-10 md:py-14 grid grid-cols-12 gap-6 items-start"
              >
                <div className="col-span-12 md:col-span-2">
                  <div className="font-editorial italic font-light text-6xl md:text-7xl text-[#E31E24] leading-none group-hover:text-[#F03B41] transition-colors duration-500">
                    {c.n}
                  </div>
                </div>
                <div className="col-span-12 md:col-span-5">
                  <h3 className="font-display font-black uppercase text-2xl md:text-3xl tracking-tight leading-tight">
                    {c.title}
                  </h3>
                </div>
                <div className="col-span-12 md:col-span-5 text-white/70 leading-relaxed text-base md:text-lg">
                  {c.body}
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
